export default "__VITE_ASSET__Crf_3YWB__"